/**
 * CList - Unified list component with multiple variants
 *
 * @example
 * import { CList, ACTIVITY_ICON_STYLES } from "@/Shared";
 *
 * // Activity variant
 * <CList variant="activity" items={activities} />
 *
 * // Avatar variant
 * <CList variant="avatar" items={members} />
 *
 * // Status variant
 * <CList variant="status" items={orders} />
 */
export { default } from "./CList";
export { default as CList } from "./CList";

// Design components (for direct use if needed)
export { default as ActivityListItem } from "./ActivityListItem";
export { default as AvatarListItem } from "./AvatarListItem";
export { default as StatusListItem } from "./StatusListItem";

// Types
export type {
  CListProps,
  ActivityListProps,
  AvatarListProps,
  StatusListProps,
  ActivityItemType,
  AvatarItemType,
  StatusItemType,
  ActivityBadgeVariant,
  AvatarBadgeVariant,
  StatusVariant,
} from "./types";

// Style constants
export {
  ACTIVITY_ICON_STYLES,
  AVATAR_BADGE_CONFIG,
  STATUS_CONFIG,
} from "./types";
